const apiUrl = process.env.REACT_APP_API_URL
const domainFrontend = process.env.REACT_APP_FRONTEND_URL
export { apiUrl, domainFrontend };